"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgNotification = props => (0, jsx_runtime_1.jsxs)("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props, {
  children: [(0, jsx_runtime_1.jsx)("path", {
    "data-name": "Regular 1.5px/notification background",
    fill: "none",
    d: "M0 0h24v24H0z"
  }, void 0), (0, jsx_runtime_1.jsx)("path", {
    d: "M12 22a4 4 0 01-4-3.8V18H3.4a1.4 1.4 0 01-1.069-2.31l.1-.1 1.03-.995a2 2 0 00.6-1.264l.008-.181-.01-3.153A7.972 7.972 0 0120 9.722V13.17a2 2 0 00.467 1.284l.119.13 1 1a1.424 1.424 0 01.414 1 1.409 1.409 0 01-1.278 1.409l-.136.007H16a4.005 4.005 0 01-4 4zm-2.5-4a2.5 2.5 0 105 0zm2.53-14.5a6.471 6.471 0 00-6.468 6.257v.233l.01 3.153a3.5 3.5 0 01-.916 2.372l-.153.157-.858.829h16.734l-.854-.853a3.493 3.493 0 01-1.018-2.262l-.007-.213V9.97a6.477 6.477 0 00-6.47-6.47z",
    fill: "#fff"
  }, void 0)]
}), void 0);

exports.default = SvgNotification;